var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCartIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 0.25C0.335786 0.25 0 0.585786 0 1C0 1.41421 0.335786 1.75 0.75 1.75H2.13568C2.30558 1.75 2.45425 1.86422 2.49803 2.02838L5.05576 11.6199C3.44178 12.0385 2.25 13.5051 2.25 15.25C2.25 15.6642 2.58579 16 3 16H18.75C19.1642 16 19.5 15.6642 19.5 15.25C19.5 14.8358 19.1642 14.5 18.75 14.5H3.87803C4.18691 13.6261 5.02034 13 6 13H17.2183C17.5051 13 17.7668 12.8364 17.8925 12.5785C19.0277 10.249 20.0183 7.83603 20.8527 5.35126C20.9191 5.15357 20.9002 4.93716 20.8005 4.75399C20.7008 4.57082 20.5294 4.43743 20.3273 4.38583C15.5055 3.15442 10.4536 2.5 5.25 2.5C4.89217 2.5 4.53505 2.5031 4.17868 2.50926L3.94738 1.64188C3.7285 0.821088 2.98515 0.25 2.13568 0.25H0.75Z",
    fill: "#262626"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 18.25C2.25 17.4216 2.92157 16.75 3.75 16.75C4.57843 16.75 5.25 17.4216 5.25 18.25C5.25 19.0784 4.57843 19.75 3.75 19.75C2.92157 19.75 2.25 19.0784 2.25 18.25Z",
    fill: "#262626"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 18.25C15 17.4216 15.6716 16.75 16.5 16.75C17.3284 16.75 18 17.4216 18 18.25C18 19.0784 17.3284 19.75 16.5 19.75C15.6716 19.75 15 19.0784 15 18.25Z",
    fill: "#262626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartIcon1);
export default __webpack_public_path__ + "static/media/cart-icon-1.b039c7c6eb3e0b040e3d9e4bda1aab85.svg";
export { ForwardRef as ReactComponent };